module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-4-small-6e3b27bd485d77cc4e3b0bf28a588266.jpg";